// extracted by mini-css-extract-plugin
module.exports = {"FormCommon":"FormCommon_FormCommon__jKg3g"};